import * as React from "react";
import Box from "@amzn/awsui-components-react/polaris/box";
import Grid from "@amzn/awsui-components-react/polaris/grid";
import Container from "@amzn/awsui-components-react/polaris/container";
import { SpaceBetween } from "@amzn/awsui-components-react";
import PropTypes from "prop-types";
import RecommendationsTable from "./RecommendationsTable";
import { RecommendationItem } from "../../calcBusterTypes";
import RecommendationsPieChart from "./RecommendationsPieChart";
import { getSavingsArray } from "../../util";
import SavingsBarChart from "./SavingsBarChart";

const RecommendationsSection: React.FC<{
  recommendations: RecommendationItem[];
  annualRunRate: number;
}> = ({ recommendations, annualRunRate }) => {
  let savings = getSavingsArray(recommendations);

  return (
    <SpaceBetween size={"l"}>
      {savings.length > 0 ? (
        <Container>
          <Grid
            gridDefinition={[
              { colspan: 1 },
              { colspan: 4 },
              { colspan: 2 },
              { colspan: 4 },
              { colspan: 1 },
            ]}
          >
            <Box />
            <RecommendationsPieChart recommendations={recommendations} />
            <Box />
            <SavingsBarChart recommendations={recommendations} />
          </Grid>
          <br />
        </Container>
      ) : (
        <></>
      )}

      <RecommendationsTable
        recommendations={recommendations}
        annualRunRate={annualRunRate}
      />
    </SpaceBetween>
  );
};

RecommendationsSection.propTypes = {
  recommendations: PropTypes.array.isRequired,
  annualRunRate: PropTypes.number.isRequired,
};

export default RecommendationsSection;
